import { mapState } from 'vuex'

export default {
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState({ categories: 'companyCategories' }),
    normalizedCategories() {
      const arr = []
      this.normalizeCategoriesRecursively(arr, this.categories, null)
      return arr
    },
    nonNullCategories() {
      if (this.normalizedCategories == null) {
        return []
      }

      return this.normalizedCategories.filter((nc) => nc)
    },
    topLevelCategories() {
      if (this.normalizedCategories == null) {
        return []
      }

      return this.normalizedCategories.filter((nc) => nc.parent == null)
    }
  },
  methods: {
    normalizeCategoriesRecursively(arr, categories, parent) {
      categories.forEach((category) => {
        arr[category.id] = {
          id: category.id,
          name: category.name,
          description: category.description,
          codes: category.codes,
          tags: category.tags,
          ranges: category.ranges,
          indeterminate: false,
          unit: category.unit,
          requirePhoto: category.requirePhoto,
          usesRanges: category.usesRanges,
          parent: parent ? parent.id : null,
          children: category.categories.map((cc) => cc.id),
          siblings: categories
            .filter((c) => c.id !== category.id)
            .map((c) => c.id)
        }
        if (category.categories && category.categories.length > 0) {
          this.normalizeCategoriesRecursively(
            arr,
            category.categories,
            category
          )
        }
      })
    },
    getCategory(id) {
      return this.normalizedCategories[id]
    },
    hasCategoryChild(id) {
      return (
        this.normalizedCategories[id] &&
        this.normalizedCategories[id].children &&
        this.normalizedCategories[id].children.length > 0
      )
    },
    getCategoryName(id) {
      return this.normalizedCategories[id]
        ? this.normalizedCategories[id].name
        : ''
    },
    getCategoryUnit(id) {
      return this.normalizedCategories[id]
        ? this.normalizedCategories[id].unit
        : ''
    },
    getCategoryTopParent(id) {
      return this.getCategoryParentRecursively(this.normalizedCategories[id])
    },
    getCategoryParentRecursively(category) {
      if (category && category.parent) {
        return this.getCategoryParentRecursively(
          this.normalizedCategories[category.parent]
        )
      } else {
        return category
      }
    },
    getSimplifiedCategoryTree() {
      const outcome = []
      this.categories.forEach((category) =>
        outcome.push(this.getSimplifiedNode(category))
      )
      return outcome
    },
    getSimplifiedNode(nodeToCopy) {
      const node = {}
      node.categoryId = nodeToCopy.id
      node.name = nodeToCopy.name
      node.categories = []
      nodeToCopy.categories.forEach((child) =>
        node.categories.push(this.getSimplifiedNode(child))
      )
      return node
    },
    getSimplifiedNormalizedCategories() {
      const outcome = []
      this.normalizeSimplifiedCategories(outcome, this.categories)
      return outcome
    },
    normalizeSimplifiedCategories(array, categories) {
      categories.forEach((category) => {
        array[category.id] = {
          id: category.id,
          isSubscribed: false
        }
        if (category.categories && category.categories.length > 0) {
          this.normalizeSimplifiedCategories(array, category.categories)
        }
      })
    },
    getDescriptionOfSubscribedCategories(array) {
      if (array.length === 0) {
        return this.getDefaultDescription()
      }
      let counter = 0
      array.forEach((item) => {
        if (this.getCategoryTopParent(item).id === item) {
          counter++
        }
      })
      if (counter === 0) {
        return this._getDescription(
          'Wybrano tylko szczegółowe kategorie',
          'black'
        )
      }
      return this._getDescription('Wybrano ' + counter, 'black')
    },
    getDefaultDescription() {
      return this._getDescription(
        'Nie wybrano kategorii obsługiwanych przez ten oddział',
        'red'
      )
    },
    _getDescription(description, color) {
      return {
        description,
        color
      }
    }
  }
}
